import React, { useState, useMemo, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import NewPagination from "components/Common/Newpagination";
import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData";
import Loader from "pages/Separate/Loader";
import secureLocalStorage from "react-secure-storage";
import { getFormattedTime } from "utils/common-helpers";
import moment from "moment-timezone";
import Swal from "sweetalert2";
import Select from "react-select";
import { timeSheetColumns } from "utils/columns/ElementsColumns/supportColumns";
import axios from "axios";
import configure from "configure";
import { otherProjectsList } from "utils/common-options";

function TableContainer({
  columns,
  data,
  selectedDate,
  setSelectedDate,
  allData,
  setData,
  open,
  setOpen,
  setIsOpen,
  staff,
  selectedAssignees,
  setSelectedAssignees,
  setLoading,
  getDataByDate,
  pendingTasks,
  setPendingTasks,
  timeStringToSeconds,
  minutesToSeconds,
  secondsToHHMMSS,
  projectOptions,
  setPtype,
  ptype,
  isClosedDay,
  setIsClosedDay,
  isAllowed,
  setIsAllowed,
  isPriviousDayClosed,
  meetingForDate,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [{ id: "timer_id", desc: true }],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  const { pageIndex, pageSize, globalFilter } = state;

  const auth_user_id = Number(localStorage.getItem("auth_id"));
  console.log(auth_user_id);
  const token = secureLocalStorage.getItem("auth_token");

  useEffect(() => {
    setPageSize(5);
  }, []);

  const isPastDate = useMemo(() => {
    const today = moment().startOf("day");
    const selected = moment(selectedDate, "YYYY-MM-DD");
    return selected.isBefore(today);
  }, [selectedDate]);

  // const isPendingTaskSubmitted = Boolean(
  //   pendingTasks && pendingTasks.length > 0
  // )
  const isPendingTaskSubmitted = useMemo(() => {
    const today = moment().startOf("day");
    const selected = moment(selectedDate, "YYYY-MM-DD");

    const isPastDate = selected.isBefore(today);
    const isTodayWithPending =
      selected.isSame(today, "day") && pendingTasks?.length > 0;

    return isPastDate || isTodayWithPending;
  }, [pendingTasks, selectedDate]);

  /* ================= MODAL STATE ================= */
  const [rows, setRows] = useState([
    {
      project: [],
      title: "",
      start_time: "",
      end_time: "",
      staff: null,
      total_time: "00:00:00",
    },
  ]);

  const todaysTasksSeconds = useMemo(() => {
    let total = 0;

    data.forEach((item) => {
      if (item.type == "activity") {
        const [h, m] = (item.total_actual_time || "0:0")?.split(":");
        total += Number(h) * 60 * 60 + Number(m) * 60;
        return;
      }

      // Case 1: start & end time exist
      // if (item.start_time && item.end_time) {
      //   const diff = moment(item.end_time).diff(moment(item.start_time))
      //   total += moment.duration(diff).asSeconds()
      //   return
      // }

      if (item?.timelogs?.length) {
        const temp_time = getFormattedTime(item?.timelogs);
        const [h = 0, m = 0, s = 0] = (temp_time || "0:0:0")
          .split(":")
          .map(Number);
        total += h * 3600 + m * 60 + s;
      }

      // Case 2: support ticket / others using minutes
      else if (item.total_actual_time && !isNaN(item.total_actual_time)) {
        total += minutesToSeconds(item.total_actual_time);
      }
    });

    return total;
  }, [data]);

  const pendingTasksSeconds = useMemo(() => {
    return rows.reduce((sum, row) => {
      if (isPendingTaskSubmitted === true && row.approved === 1) {
        return sum + timeStringToSeconds(row.total_time || "00:00:00");
      }
      return sum;
    }, 0);
  }, [rows]);

  const allPendingTasksSeconds = useMemo(() => {
    return rows.reduce((sum, row) => {
      if (isPendingTaskSubmitted === true) {
        return sum + timeStringToSeconds(row.total_time || "00:00:00");
      }
      return sum;
    }, 0);
  }, [rows]);

  const totalTodaysTime = useMemo(() => {
    return secondsToHHMMSS(todaysTasksSeconds + pendingTasksSeconds);
  }, [todaysTasksSeconds, pendingTasksSeconds]);

  const totalTodaysTimeMain = useMemo(() => {
    return secondsToHHMMSS(todaysTasksSeconds + allPendingTasksSeconds);
  }, [todaysTasksSeconds, allPendingTasksSeconds]);

  useEffect(() => {
    if (!pendingTasks || pendingTasks.length === 0) {
      //Don't wipe meeting rows if already populated
      setRows((prev) => {
        const hasMeetingRows = prev.some((r) => r.fromMeeting);
        if (hasMeetingRows) return prev;
        return [
          {
            project: "",
            title: "",
            start_time: "",
            end_time: "",
            staff: null,
            total_time: "00:00:00",
          },
        ];
      });
      return;
    }

    const mappedRows = pendingTasks.map((task) => ({
      title: task.title || "",
      start_time: task.start_time || "",
      end_time: task.end_time || "",
      staff: task.staff || "",
      total_time: task.totaltime || "00:00:00",
      approved: task.approved,
      project: {
        type: task.project_type,
        value: task.project_type == 2 ? task.other_project_id : task.project_id,
      },
    }));

    setRows(mappedRows);
  }, [pendingTasks]);

  /* ================= HELPERS ================= */
  const calculateRowTime = (start, end) => {
    if (!start || !end) return "00:00:00";

    // Force same date so moment can calculate
    const s = moment(`1970-01-01 ${start}`, "YYYY-MM-DD HH:mm");
    const e = moment(`1970-01-01 ${end}`, "YYYY-MM-DD HH:mm");

    if (!s.isValid() || !e.isValid()) return "00:00:00";
    if (e.isBefore(s)) return "00:00:00";

    const diff = moment.duration(e.diff(s));

    return `${String(Math.floor(diff.asHours())).padStart(2, "0")}:${String(
      diff.minutes(),
    ).padStart(2, "0")}:${String(diff.seconds()).padStart(2, "0")}`;
  };

  //converts using each meeting's own stored timezone
  useEffect(() => {
    if (!meetingForDate?.length) return;

    const meetingRows = meetingForDate.map((m) => {
      const tz = m.timezone || "UTC";
      // Convert UTC start/end into the meeting's local timezone
      const start = moment.utc(m.start).tz(tz).format("HH:mm");
      const end = moment.utc(m.end).tz(tz).format("HH:mm");

      return {
        project: "",
        title: m.title || "Meeting",
        start_time: start,
        end_time: end,
        fromMeeting: true, // locks start_time from editing
        staff: null,
        total_time: calculateRowTime(start, end),
      };
    });

    // Only set meeting rows if no real data is present yet
    setRows((prev) => {
      // const hasRealData = prev.some(r => r.title || r.start_time)
      const hasRealData = prev.some(
        (r) =>
          r.fromMeeting ||
          r.approved !== undefined ||
          (r.title && !r.fromMeeting),
      );
      if (hasRealData) return prev;
      return meetingRows;
    });
  }, [meetingForDate]);

  const handleRowChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;

    if (field === "start_time" || field === "end_time") {
      const { start_time, end_time } = updated[index];

      if (start_time && end_time) {
        const start = moment(start_time);
        const end = moment(end_time);

        if (end.isBefore(start)) {
          Swal.fire({
            icon: "warning",
            title: "Invalid Time",
            text: "End time cannot be earlier than start time",
          });
          return;
        }

        updated[index].total_time = calculateRowTime(start_time, end_time);
      }
    }

    setRows(updated);
  };

  const addRow = () => {
    setRows([
      ...rows,
      {
        project: "",
        title: "",
        start_time: "",
        end_time: "",
        staff: null,
        total_time: "00:00:00",
      },
    ]);
  };

  const deleteRow = (index) => {
    if (rows.length === 1) return;
    setRows(rows.filter((_, i) => i !== index));
  };

  const totalHours = useMemo(() => {
    let totalSeconds = 0;

    rows.forEach((r) => {
      const [h = 0, m = 0, s = 0] = r.total_time.split(":").map(Number);
      totalSeconds += h * 3600 + m * 60 + s;
    });

    const d = moment.duration(totalSeconds, "seconds");
    return `${String(Math.floor(d.asHours())).padStart(2, "0")}:${String(
      d.minutes(),
    ).padStart(2, "0")}:${String(d.seconds()).padStart(2, "0")}`;
  }, [rows]);

  const totalPendingHours = useMemo(() => {
    let totalSeconds = 0;

    rows
      ?.filter((item) => item.approved != 1)
      ?.forEach((r) => {
        const [h = 0, m = 0, s = 0] = r?.total_time?.split(":").map(Number);
        totalSeconds += h * 3600 + m * 60 + s;
      });

    const d = moment.duration(totalSeconds, "seconds");
    return `${String(Math.floor(d.asHours())).padStart(2, "0")}:${String(
      d.minutes(),
    ).padStart(2, "0")}:${String(d.seconds()).padStart(2, "0")}`;
  }, [rows]);

  const handleSubmitPendingTasks = async () => {
    try {
      // Validate rows
      const validRows = rows.filter(
        (r) => r.title && r.start_time && r.end_time,
      );

      if (validRows.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "No valid rows",
          text: "Please fill at least one valid row before submitting",
        });
        return;
      }

      Swal.fire({
        title: "Are you Sure!",
        text: "By Confirming You wont be able to update your Additional Activities anymore.",

        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes! do it",
        cancelButtonText: "No",
      }).then(async (confirm) => {
        if (confirm.isConfirmed) {
          const payload = validRows.map((r) => ({
            title: r.title,
            start_time: r.start_time,
            end_time: r.end_time,
            staff: r.staff,
            totaltime: r.total_time,
            userId: auth_user_id,
            project: r.project || [],
            date: selectedDate,
          }));

          const res = await FetchNodePostData(
            setLoading,
            "pendingTasks",
            token,
            payload,
          );

          if (res?.data?.success) {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Pending tasks saved successfully",
            });
            getDataByDate(selectedDate);
          }
        }
      });
    } catch (error) {
      console.error("Submit pending tasks error:", error);
    }
  };

  const handleCloseDay = async () => {
    try {
      Swal.fire({
        title: "Are you Sure!",
        text: "You want to close your day!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes! do it",
        cancelButtonText: "No",
      }).then(async (confirm) => {
        if (confirm.isConfirmed) {
          const payload = {
            id: auth_user_id,
            tasks: "",
            other_tasks: "",
            date: selectedDate || moment().format("YYYY-MM-DD"),
          };

          const res = await FetchNodePostData(
            setLoading,
            "alltodaysTasks/post",
            token,
            payload,
          );
          if (res.data?.success)
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Day has been Closed",
            });
          else {
            swal("", "Something went wrong!", "error");
          }
          // setIsClosedDay(true)
          getDataByDate(selectedDate);
        }
      });
    } catch (error) {
      console.error("Submit pending tasks error:", error);
      swal("", "Something went wrong!", "error");
    }
  };

  const safeTime =
    totalTodaysTime && totalTodaysTime.startsWith("-")
      ? "00:00:00"
      : totalTodaysTime || "00:00:00";

  const isDisabled = isPendingTaskSubmitted && !isAllowed;
  const isAllowEntry = !isPendingTaskSubmitted || isAllowed;
  return (
    <div>
      {/* ================= HEADER ================= */}
      <Row>
        <Col md="12">
          <div className="card-body">
            <div className="d-flex justify-content-between modal-header mb-3">
              <div className=" text-purple fs-5 fw-bold d-flex gap-3">
                Timesheet Data{" "}
                <span className="text-dark">
                  ( {localStorage.getItem("auth_name")} )
                </span>
              </div>
              {/* {isPriviousDayClosed === false && (
                <div
                  className="alert alert-warning d-flex align-items-center gap-2 ms-5 mt-2"
                  role="alert"
                  style={{ fontWeight: "bold", fontSize: "0.8rem" }}
                >
                  ⚠️ Your previous day's "Day Close" is pending!
                </div>
              )} */}

              <div className="flex-grow-1 d-flex justify-content-end gap-4 ">
                <div className="col-auto">
                  <input
                    type="date"
                    className="form-control "
                    value={selectedDate}
                    max={new Date().toISOString().split("T")[0]}
                    onChange={(e) => setSelectedDate(e.target.value)}
                  />
                </div>
                <div className="cusrtom_search_box ">
                  <div className="search-box me-xxl-2 my-xxl-0 d-inline-block w-100">
                    <div className="position-relative w-100">
                      <input
                        onChange={(e) => setGlobalFilter(e.target.value)}
                        type="text"
                        className=" form-control h-100 w-100"
                        placeholder="Search..."
                        value={globalFilter || ""}
                      />
                      <i className="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                </div>
                <button
                  disabled={
                    isClosedDay ||
                    (moment().format("YYYY-MM-DD") !== selectedDate &&
                      !isAllowed)
                  }
                  className={`btn text-white me-2 btn-${
                    isClosedDay ? "success" : "primary"
                  } text-uppercase btn-label`}
                  onClick={() => {
                    if (!isClosedDay) {
                      handleCloseDay();
                    }
                  }}
                >
                  <i className="fa fa-check-circle  me-2 icon-center label-icon"></i>
                  {isClosedDay ? "Day Closed" : "close your day"}
                </button>

                <button
                  className="s btn btn-red btn-label"
                  onClick={() => setIsOpen(false)}
                >
                  <i className="dripicons-cross me-2 icon-center label-icon"></i>
                  CANCEL
                </button>
                {/* <div className=" text-end">
                  
                  <button
                    type="button"
                    onClick={() => setIsOpen(false)}
                    className="btn-modal-close"
                  >
                    <span aria-hidden="true" className="btn-modal-span">
                      &times;
                    </span>
                  </button>
                </div> */}
              </div>
            </div>

            {/* <h5 className="text-purple mb-0">Total Today's Time :</h5>
              <h5 className="text-primary mb-0">
                <h5
                  className={`mb-0 ${
                    safeTime < "08:00:00" ? "text-danger" : "text-primary"
                  }`}
                >
                  {safeTime}
                </h5>
              </h5> */}

            {/* ================= MAIN TABLE ================= */}
            <Row className="px-4">
              {/* ================= LEFT : MAIN TABLE ================= */}
              <Col md="12" className="pb-4">
                <div className="text-purple fs-5 fw-bold d-flex justify-content-between align-items-center mb-3 mt-1">
                  {/* Left Side */}
                  <div className="d-flex align-items-center gap-3">
                    <div>Today's Tasks</div>

                    <div className="d-flex gap-3 fs-6 align-items-center">
                      <div className="general-box bg-light px-3 fw-semibold text-purple">
                        Verified Time : {safeTime}
                      </div>

                      <div className="general-box bg-light px-3 fw-semibold text-purple">
                        Unverified Time : {totalPendingHours}
                      </div>

                      <div className="general-box px-3 fw-semibold text-purple"
                        style={{color: "purple", border: "1px solid purple"}}
                      >
                        Total Time : {totalTodaysTimeMain}
                      </div>
                    </div>
                  </div>

                  {/* Right Side */}
                  {isPriviousDayClosed === false && (
                    <div
                      className="alert alert-warning px-2 py-1 mb-0 fw-semibold"
                      style={{ fontSize: "0.80rem", display: "inline-block" }}
                    >
                      ⚠️ Previous day's "Day Close" pending
                    </div>
                  )}
                </div>
                <div className="table-responsive">
                  <Table bordered {...getTableProps()}>
                    <thead>
                      {headerGroups.map((hg, i) => (
                        <tr key={i} {...hg.getHeaderGroupProps()}>
                          {hg.headers.map((col, idx) => (
                            <th
                              key={idx}
                              {...col.getHeaderProps(
                                col.getSortByToggleProps(),
                              )}
                              className={col.className}
                            >
                              {col.render("Header")}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                      {page.map((row, i) => {
                        prepareRow(row);
                        return (
                          <tr key={i} {...row.getRowProps()}>
                            {row.cells.map((cell, idx) => (
                              <td
                                key={idx}
                                {...cell.getCellProps()}
                                className={cell.column.className}
                              >
                                {cell.render("Cell")}
                              </td>
                            ))}
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                <NewPagination
                  gotoPage={gotoPage}
                  canPreviousPage={canPreviousPage}
                  previousPage={previousPage}
                  canNextPage={canNextPage}
                  pageIndex={pageIndex}
                  pageOptions={pageOptions}
                  pageSize={pageSize}
                  page={page}
                  data={data}
                  nextPage={nextPage}
                />
              </Col>

              {/* ================= RIGHT : TASK TIME DETAILS ================= */}
              <Col md="12" className="pt-4 border-top">
                {/* ===== Header with Submit Button ===== */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div className="text-purple fs-5 fw-bold">
                    Additional Activities
                  </div>
                  <div className="d-flex gap-4 align-items-center">
                    <h5 className="text-purple mb-0">
                      Total Hours :
                      <span className="text-primary ms-2">{totalHours}</span>
                    </h5>
                    {isAllowEntry ? (
                      <button
                        type="submit"
                        className=" btn ms-md-2 btn-save btn-label"
                        disabled={isDisabled}
                        onClick={handleSubmitPendingTasks}
                      >
                        <i className="fas fa-save me-1 label-icon"></i> Submit
                      </button>
                    ) : null}
                  </div>
                </div>

                <div>
                  <Table bordered>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th className="col-2">
                          Project
                          <select
                            value={ptype}
                            onChange={(e) => setPtype(e.target.value)}
                            className="ms-3 badge bg-light border text-dark fw-semibold"
                            disabled={isDisabled}
                          >
                            <option value="0">Development</option>
                            <option value="1">Digital Marketing</option>
                            <option value="2">Others</option>
                          </select>
                        </th>
                        <th>Activity Name</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th className="col-2">Collaborate With</th>
                        <th>Total Time</th>
                        <th>
                          {!isPendingTaskSubmitted ? "Action" : "Approval"}
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {rows.map((row, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>

                          <td>
                            {isAllowEntry ? (
                              <Select
                                placeholder="Select Here"
                                className="basic-multi-select"
                                classNamePrefix="select"
                                options={projectOptions}
                                value={
                                  projectOptions.find(
                                    (s) => s.value === row.project?.value,
                                  ) || null
                                }
                                isClearable
                                onChange={(option) => {
                                  handleRowChange(i, "project", option || "");
                                }}
                              />
                            ) : (
                              <input
                                className="form-control"
                                value={
                                  projectOptions.find(
                                    (s) => s.value == row.project?.value,
                                  )?.label || ""
                                }
                                disabled
                              />
                            )}
                          </td>

                          <td>
                            <input
                              className="form-control"
                              placeholder="Enter Activity"
                              value={row.title}
                              disabled={isDisabled}
                              onChange={(e) =>
                                handleRowChange(i, "title", e.target.value)
                              }
                            />
                          </td>

                          <td>
                            <input
                              type="time"
                              className="form-control"
                              value={row.start_time}
                              disabled={isDisabled || row.fromMeeting}
                              onChange={(e) =>
                                handleRowChange(i, "start_time", e.target.value)
                              }
                            />
                          </td>

                          <td>
                            <input
                              type="time"
                              className="form-control"
                              value={row.end_time}
                              disabled={isDisabled}
                              onChange={(e) =>
                                handleRowChange(i, "end_time", e.target.value)
                              }
                            />
                          </td>

                          <td>
                            {isAllowEntry ? (
                              <Select
                                placeholder="Member"
                                className="basic-multi-select"
                                classNamePrefix="select"
                                options={staff}
                                value={
                                  staff.find((s) => s.value === row.staff) ||
                                  null
                                }
                                isClearable
                                onChange={(option) =>
                                  handleRowChange(
                                    i,
                                    "staff",
                                    option?.value || "",
                                  )
                                }
                              />
                            ) : (
                              <input
                                className="form-control"
                                value={
                                  staff.find((s) => s.value === row.staff)
                                    ?.label || "--"
                                }
                                disabled
                              />
                            )}
                          </td>

                          <td className="fw-bold text-primary text-center">
                            {row.total_time}
                          </td>

                          <td className="text-center">
                            {isAllowEntry ? (
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() => deleteRow(i)}
                                disabled={isDisabled}
                              >
                                ✕
                              </button>
                            ) : (
                              <>
                                {row.approved == 1 ? (
                                  <i className="bi bi-check-circle icon-center text-success fs-4"></i>
                                ) : row.approved == 2 ? (
                                  <i className="bi bi-x-circle icon-center  text-danger fs-4"></i>
                                ) : (
                                  <i className="bi bi-exclamation-circle icon-center text-warning fs-4"></i>
                                )}
                              </>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>

                  <div className="d-flex justify-content-end mt-3">
                    {/* <button className="btn btn-primary" onClick={addRow}>
                      + Add Row
                    </button> */}
                    <button
                      className="s btn text-white me-2 btn-primary btn-label"
                      disabled={isDisabled}
                      onClick={isAllowEntry ? addRow : undefined}
                    >
                      <i className="fas fa-plus me-2 icon-size label-icon"></i>
                      Row
                    </button>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      {/* ================= MODAL ================= */}
      <Modal isOpen={open} toggle={() => setOpen(false)} size="xl" centered>
        <ModalHeader toggle={() => setOpen(false)}>
          Task Time Details
        </ModalHeader>

        <ModalBody>
          <Table bordered>
            <thead className="">
              <tr>
                <th>#</th>
                <th>Title</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th>Staff</th>
                <th>Total Time</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {rows.map((row, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>
                    <input
                      className="form-control"
                      value={row.title}
                      onChange={(e) =>
                        handleRowChange(i, "title", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="datetime-local"
                      className="form-control"
                      value={row.start_time}
                      onChange={(e) =>
                        handleRowChange(i, "start_time", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="datetime-local"
                      className="form-control"
                      value={row.end_time}
                      onChange={(e) =>
                        handleRowChange(i, "end_time", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <input
                      className="form-control"
                      value={row.staff}
                      onChange={(e) =>
                        handleRowChange(i, "staff", e.target.value)
                      }
                    />
                  </td>
                  <td className="fw-bold text-primary text-center">
                    {row.total_time}
                  </td>
                  <td className="text-center">
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => deleteRow(i)}
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <div className="d-flex justify-content-between mt-3">
            <button className="btn btn-primary" onClick={addRow}>
              + Add Row
            </button>

            <h5 className="text-purple mb-0">
              Total Hours :
              <span className="text-primary ms-2">{totalHours}</span>
            </h5>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

const TimesheetReport = ({ setIsOpen }) => {
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedAssignees, setSelectedAssignees] = useState([]);
  const [pendingTasks, setPendingTasks] = useState([]);
  const [isPriviousDayClosed, setIsPriviousDayClosed] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0],
  );

  const auth_user_id = Number(localStorage.getItem("auth_id"));
  const token = secureLocalStorage.getItem("auth_token");

  const timeStringToSeconds = (time = "00:00:00") => {
    const [h = 0, m = 0, s = 0] = time.split(":").map(Number);
    return h * 3600 + m * 60 + s;
  };

  const minutesToSeconds = (minutes = 0) => Number(minutes) * 60;

  const secondsToHHMMSS = (totalSeconds) => {
    const d = moment.duration(totalSeconds, "seconds");
    return `${String(Math.floor(d.asHours())).padStart(2, "0")}:${String(
      d.minutes(),
    ).padStart(2, "0")}:${String(d.seconds()).padStart(2, "0")}`;
  };

  const [allBookingData, setAllBookingData] = useState([]);

  const getMeetings = async () => {
    const formEntries = { id: [auth_user_id] }; // only current user's id
    const res = await FetchNodePostData(
      toggleLoading,
      `calender/get`,
      token,
      formEntries,
    );
    if (res?.status) {
      // const dataArray = Array.isArray(res?.data) ? res.data : []
      const dataArray = res?.data?.data;

      if (!Array.isArray(dataArray)) {
        console.warn("meetings data is not an array:", dataArray);
        return;
      }

      const meetData = dataArray.map((teamItem, index) => ({
        row_id: index + 1,
        title: teamItem.title,
        startDate: teamItem?.start,
        endDate: teamItem?.end,
        ...teamItem,
      }));

      console.log("data from response is :", res.data);
      console.log("data from meetdata is :", meetData);
      setAllBookingData(meetData || []);
    }
  };

  const meetingForDate = useMemo(() => {
    return allBookingData.filter((m) => {
      const tz = m.timezone || "UTC";
      const localDate = moment.utc(m.start).tz(tz).format("YYYY-MM-DD");
      return localDate === selectedDate;
    });
  }, [allBookingData, selectedDate]);

  const [isClosedDay, setIsClosedDay] = useState(false);
  const [isAllowed, setIsAllowed] = useState(false);

  const [staff, setStaff] = useState([]);
  const [ptype, setPtype] = useState(0);
  const [projectOptions, setprojectOptions] = useState([]);
  const [digital_projects, setdigital_projects] = useState([]);

  // getting all staff & projects
  useEffect(() => {
    const fetch = async () => {
      try {
        const datas = await fetchNodeData(toggleLoading, "generalData", token);

        const allStaffOption = datas?.data?.staff?.map((obj) => {
          return {
            label: obj?.name,
            value: obj.id,
          };
        });

        const devProjects = datas?.data?.projects?.map((obj) => {
          return {
            label: obj?.project_name,
            value: obj.id,
          };
        });

        const dmProjects = datas?.data?.digital_projects?.map((obj) => {
          return {
            label: obj?.project_name,
            value: obj.id,
          };
        });

        setprojectOptions(devProjects || []);
        setdigital_projects(dmProjects || []);
        setStaff(allStaffOption || []);
      } catch (err) {
        console.log(err);
      }
    };

    fetch();
  }, []);

  const [allProjects, setAllProjects] = useState([]);

  const toggleLoading = (loading) => {
    setLoading(loading);
  };

  const GetData = async (dateParam = selectedDate) => {
    const res = await fetchNodeData(
      toggleLoading,
      `todaysTasks/${auth_user_id}/${dateParam}`,
      token,
    );

    if (res && res.status) {
      setData(res.tasks || []);
      setAllData(res.tasks || []);
    } else {
      setData([]);
    }
  };

  // get timesheet data
  const getDataByDate = async (selectedDate = selectedDate) => {
    try {
      setLoading(true);
      const id = localStorage.getItem("auth_id");
      const auth_id = Number(localStorage.getItem("auth_id"));
      console.log("auth user id is : ", auth_user_id);
      const res = await axios.get(
        // `${configure.nodeApi}/workLoad/${selectedDate}`
        `${configure.nodeApi}/TimeSheetReport/${selectedDate}/${selectedDate}/${auth_id}`,
      );

      const res2 = await axios.get(
        `${configure.nodeApi}/pendingTasks/${auth_id}/${selectedDate}/${selectedDate}`,
      );

      if (res?.data?.success) {
        const fetchedData = res.data?.data?.allData;

        console.log("fetchedData", fetchedData, auth_user_id);

        const filteredData = fetchedData
          .filter((item) => {
            const isOwner =
              item.user_id === auth_user_id ||
              item.staff_id === auth_user_id ||
              item?.user?.id === auth_user_id;
            // item.added_by === auth_user_id  ||

            // const isAssigned = item.assigned
            //   ? item.assigned
            //       .split(",")
            //       .map((id) => Number(id.trim()))
            //       .includes(auth_user_id)
            //   : false;

            // Apply time condition globally
            return isOwner && item.total_actual_time;
          })
          ?.map((item) => ({
            ...item,
            date: moment(item.updated_at).format("DD-MM-YYYY"),
            ...(item.type != "activity" && item?.timelogs
              ? {
                  todayTime: getFormattedTime(item?.timelogs || []),
                  // getFormattedTime(item?.start_time, item?.end_time) || null,
                }
              : {}),
          }));
        setData(filteredData);
      }

      if (res2?.data?.success) {
        setIsClosedDay(res2.data?.isClosed);

        setIsAllowed(res2.data?.isAllowed);

        setPendingTasks(res2.data.data);
        setIsPriviousDayClosed(res2.data?.isPreviousClosed);

        if (res2.data.data?.length) {
          setPtype(res2.data.data[0].project_type);
        }
      }

      setLoading(false);
    } catch (error) {
      console.error(
        `Error fetching Timesheet data for date ${selectedDate}`,
        error,
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    // GetData(selectedDate)
    getDataByDate(selectedDate);
  }, [selectedDate]);

  useEffect(() => {
    getMeetings();
  }, []);

  useEffect(() => {
    getProjects();
  }, [ptype]);

  const getProjects = async () => {
    try {
      if (ptype == 2) {
        setAllProjects(otherProjectsList);
        return;
      }

      const res = await fetchNodeData(
        setLoading,
        `userProject/asignedProjects/${auth_user_id}/${ptype}`,
        token,
      );

      const allProjects = res?.data?.map((obj) => {
        return {
          label: obj?.project_name,
          value: obj.id,
          type: ptype,
        };
      });

      setAllProjects(allProjects || []);
    } catch (error) {
      console.error("Error getting projects:", error);
    }
  };

  // const columns = useMemo(() => TodaysTaskColumns(), [])
  const columns = useMemo(() => timeSheetColumns(), []);

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <Row>
        <Col lg="12">
          <Card>
            <div className="responsive-table">
              <TableContainer
                columns={columns}
                data={data}
                allData={allData}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                setData={setData}
                open={open}
                setOpen={setOpen}
                setIsOpen={setIsOpen}
                staff={staff}
                selectedAssignees={selectedAssignees}
                setSelectedAssignees={setSelectedAssignees}
                setLoading={setLoading}
                getDataByDate={getDataByDate}
                pendingTasks={pendingTasks}
                setPendingTasks={setPendingTasks}
                timeStringToSeconds={timeStringToSeconds}
                minutesToSeconds={minutesToSeconds}
                secondsToHHMMSS={secondsToHHMMSS}
                projectOptions={allProjects}
                setPtype={setPtype}
                ptype={ptype}
                isClosedDay={isClosedDay}
                setIsClosedDay={setIsClosedDay}
                isAllowed={isAllowed}
                setIsAllowed={setIsAllowed}
                isPriviousDayClosed={isPriviousDayClosed}
                meetingForDate={meetingForDate}
              />
            </div>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default TimesheetReport;
